import { useCallback, useState, useEffect } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { Select } from '../../select'
import { JobBoard, FeaturedBoard } from './components'

import * as styles from './GreenhouseModule.module.scss'

const GreenhouseModule = () => {
  const [t] = useTranslation()
  const [jobs, setJobs] = useState([])
  const [allJobs, setAlljobs] = useState([])
  const [locations, setLocations] = useState([])
  const [departments, setDepartment] = useState([])
  const [roleTypes, setRoleTypes] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [locationFilterValue, setLocationFilterValue] = useState('All Locations')
  const [roleFilterValue, setRoleFilterValue] = useState('All Role Types')
  const [departmentFilterValue, setDepartmentFilterValue] = useState('All Departments')
  const [featuredJobs, setFeaturedJobs] = useState([])

  async function requestJobs() {
    const result = await axios({
      method: 'get',
      url: 'https://boards-api.greenhouse.io/v1/boards/elevationscreditunion/jobs',
    })
    if (result.status !== 200 || !result.data || !result.data.jobs) {
      throw new Error('Unexpected response')
    }
    const ecuJobs = []
    result.data.jobs.forEach(job => {
      let tmpLocation
      if (job.location.name === 'Remote') {
        tmpLocation = 'Remote, Colorado, United States'
      } else {
        tmpLocation = job.location.name
      }
      const tmpJob = {}
      tmpJob.absolute_url = job.absolute_url
      tmpJob.location = tmpLocation
      tmpJob.title = job.title
      for (let i = 0; i <= 3; i += 1) {
        if (job.metadata[i].name === 'Employment Type') {
          tmpJob.employment_type = job.metadata[i].value
        }
      }
      for (let j = 0; j <= 3; j += 1) {
        if (job.metadata[j].name === 'Organization') {
          tmpJob.organization = job.metadata[j].value
        }
      }
      for (let k = 0; k <= 3; k += 1) {
        if (job.metadata[k].name === 'Featured') {
          tmpJob.featured = job.metadata[k].value
        }
      }
      for (let l = 0; l <= 3; l += 1) {
        if (job.metadata[l].name === 'Job Board Department') {
          tmpJob.department = job.metadata[l].value
        }
      }
      ecuJobs.push(tmpJob)
    })
    const newJobs = ecuJobs.map(job => {
      const tmpJob = job
      if (tmpJob.location === null) {
        tmpJob.location = 'Not Specified'
      }
      if (tmpJob.department === null) {
        tmpJob.department = 'Not Specified'
      }
      return tmpJob
    })

    return newJobs
  }

  const setFilters = data => {
    const locationMap = [...new Set(data.map(item => item.location))]
    const cleanedLocationMap = locationMap.map(location => location.replace(', United States', ''))
    setLocations(cleanedLocationMap)
    const departmentMap = [...new Set(data.map(item => item.department))]
    departmentMap.sort((a, b) => a.localeCompare(b))
    setDepartment(departmentMap)
    const roleTypeMap = [...new Set(data.map(item => item.employment_type))]
    setRoleTypes(roleTypeMap)
    setIsLoading(false)
  }

  const getFeaturedJobs = data => {
    const newFeaturedJobs = data.filter(job => job.featured === true)
    setFeaturedJobs(newFeaturedJobs)
  }

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      const data = await requestJobs()
      setJobs(data)
      setAlljobs(data)
      setFilters(data)
      getFeaturedJobs(data)
    }
    fetchData()
  }, [])

  const handleOtherFilters = (filter, changed) => {
    const currentLocation = locationFilterValue
    const currentRole = roleFilterValue
    const currentDep = departmentFilterValue
    let jobsToBeFiltered = allJobs
    if (!changed) {
      if (currentLocation !== 'All Locations' && filter !== 'location') {
        const filteringLocation = currentLocation.concat(', United States')
        const locationTmpJobs = jobsToBeFiltered.filter(
          job => job.location.name === filteringLocation
        )
        jobsToBeFiltered = locationTmpJobs
      }
      if (currentDep !== 'All Departments' && filter !== 'department') {
        const depTmpJobs = jobsToBeFiltered.filter(job => job.department === currentDep)
        jobsToBeFiltered = depTmpJobs
      }
      if (currentRole !== 'All Role Types' && filter !== 'role') {
        const roleTmpJobs = jobsToBeFiltered.filter(job => job.employment_type === currentRole)
        jobsToBeFiltered = roleTmpJobs
      }
    }
    if (changed) {
      if (filter === 'location') {
        if (changed === 'All Locations') {
          jobsToBeFiltered = allJobs
        } else {
          const filteringLocation = changed.concat(', United States')
          const locationTmpJobs = jobsToBeFiltered.filter(job => job.location === filteringLocation)
          jobsToBeFiltered = locationTmpJobs
        }
        if (currentDep !== 'All Departments') {
          const depTmpJobs = jobsToBeFiltered.filter(job => job.department === currentDep)
          jobsToBeFiltered = depTmpJobs
        }
        if (currentRole !== 'All Role Types') {
          const roleTmpJobs = jobsToBeFiltered.filter(job => job.employment_type === currentRole)
          jobsToBeFiltered = roleTmpJobs
        }
      }
      if (filter === 'department') {
        if (changed === 'All Departments') {
          jobsToBeFiltered = allJobs
        } else {
          const depTmpJobs = jobsToBeFiltered.filter(job => job.department === changed)
          jobsToBeFiltered = depTmpJobs
        }
        if (currentLocation !== 'All Locations') {
          const filteringLocation = currentLocation.concat(', United States')
          const locationTmpJobs = jobsToBeFiltered.filter(job => job.location === filteringLocation)
          jobsToBeFiltered = locationTmpJobs
        }
        if (currentRole !== 'All Role Types') {
          const roleTmpJobs = jobsToBeFiltered.filter(job => job.employment_type === currentRole)
          jobsToBeFiltered = roleTmpJobs
        }
      }
      if (filter === 'role') {
        if (changed === 'All Role Types') {
          jobsToBeFiltered = allJobs
        } else {
          const roleTmpJobs = jobsToBeFiltered.filter(job => job.employment_type === changed)
          jobsToBeFiltered = roleTmpJobs
        }
        if (currentLocation !== 'All Locations') {
          const filteringLocation = currentLocation.concat(', United States')
          const locationTmpJobs = jobsToBeFiltered.filter(job => job.location === filteringLocation)
          jobsToBeFiltered = locationTmpJobs
        }
        if (currentDep !== 'All Departments') {
          const depTmpJobs = jobsToBeFiltered.filter(job => job.department === currentDep)
          jobsToBeFiltered = depTmpJobs
        }
      }
    }
    setJobs(jobsToBeFiltered)
    setIsLoading(false)
  }

  const onLocationChange = event => {
    setIsLoading(true)
    const selectedLocation = event.target.value
    setLocationFilterValue(selectedLocation)
    handleOtherFilters('location', selectedLocation)
  }

  const onClearFilters = event => {
    setIsLoading(true)
    setJobs(allJobs)
    setLocationFilterValue('All Locations')
    setDepartmentFilterValue('All Departments')
    setRoleFilterValue('All Role Types')
    setIsLoading(false)
  }

  const onDepartmentChange = event => {
    setIsLoading(true)
    const selectedDepartment = event.target.value
    setDepartmentFilterValue(selectedDepartment)
    handleOtherFilters('department', selectedDepartment)
  }

  const onTypeChange = event => {
    setIsLoading(true)
    const selectedType = event.target.value
    setRoleFilterValue(selectedType)
    handleOtherFilters('role', selectedType)
  }

  return (
    <div className={styles.mainContainer}>
      {!isLoading && featuredJobs.length > 0 && <FeaturedBoard jobs={featuredJobs} />}
      <div className={styles.filerContainer}>
        <div className={styles.locationFilter}>
          {!isLoading && locations.length > 0 && (
            <Select
              label={`${t('OpenPositions.locationFilter', {
                defaultValue: 'Filter By Location',
              })}`}
              id="locationFilterId"
              name="locationFilterId"
              onChange={onLocationChange}
              value={locationFilterValue}
              aria-controls="locations"
            >
              <Select.Option value="All Locations">All Locations</Select.Option>
              {locations.map(location => {
                return (
                  <Select.Option key={location} value={location} id="locations">
                    {location}
                  </Select.Option>
                )
              })}
            </Select>
          )}
        </div>
        <div className={styles.departmentFilter}>
          {!isLoading && departments.length > 0 && (
            <Select
              label={`${t('OpenPositions.departmentFilter', {
                defaultValue: 'Filter By Department',
              })}`}
              id="departmentFilterId"
              name="departmentFilterId"
              onChange={onDepartmentChange}
              value={departmentFilterValue}
              aria-controls="department"
            >
              <Select.Option value="All Departments">All Departments</Select.Option>
              {departments.map(department => {
                return (
                  <Select.Option key={department} value={department} id="department">
                    {department}
                  </Select.Option>
                )
              })}
            </Select>
          )}
        </div>
        <div className={styles.roleFilter}>
          {!isLoading && roleTypes && (
            <Select
              label={`${t('OpenPositions.roleFilter', {
                defaultValue: 'Filter By Role',
              })}`}
              id="roleFilterId"
              name="roleFilterId"
              onChange={onTypeChange}
              value={roleFilterValue}
              aria-controls="RoleType"
            >
              <Select.Option value="All Role Types">All Role Types</Select.Option>
              {roleTypes.map(roleType => {
                return (
                  <Select.Option key={roleType} value={roleType} id="RoleType">
                    {roleType}
                  </Select.Option>
                )
              })}
            </Select>
          )}
        </div>
        <button type="button" className={styles.clearFilterButton} onClick={onClearFilters}>
          Clear all filters
        </button>
      </div>
      <JobBoard jobs={jobs} />
    </div>
  )
}
export { GreenhouseModule }
export default GreenhouseModule
